import { render, staticRenderFns } from "./TitularPropietario.vue?vue&type=template&id=f41c6d04&"
import script from "./TitularPropietario.vue?vue&type=script&lang=js&"
export * from "./TitularPropietario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports